export default __webpack_public_path__ + "static/media/whiteCircle.e4a4f3aa.svg";